export default "__VITE_ASSET__B7qo19d3__$_?nuxt_component=async&nuxt_component_name=SvgoEducation&nuxt_component_export=default__"